import {
  AfterViewInit,
  ViewChildren,
  QueryList,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Injector,
  ViewChild,
  AfterViewChecked,
  ElementRef,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
  TrackByFunction
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EinvoiceStatusComponent } from '@components/einvoice/einv-status/einv-status.component';
import {
  ColumnOptions,
  COUNTRY_OPTIONS,
  EINVOICE_STOCK_CLASSIFICATION
} from '@core';
import { ACLService } from '@delon/acl';
import { _HttpClient, SettingsService } from '@delon/theme';
import { Store } from '@ngrx/store';
import { DocEditActionsComponent } from '@shared-feature/components/actions/doc-edit-actions/doc-edit-actions.component';
import { DeferredVatLookupService } from '@shared-feature/services/lookup-deferredvat.service';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzResizeEvent } from 'ng-zorro-antd/resizable';
import { NzTableComponent } from 'ng-zorro-antd/table';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { removeRecentAgentAction } from 'src/app/actions/agent';
import { removeRecentCustomerAction } from 'src/app/actions/customer/action';
import { removeRecentProjectAction } from 'src/app/actions/project';
import { removeRecentStockAction } from 'src/app/actions/stock';
import { removeRecentTaxAction } from 'src/app/actions/tax';
import { removeRecentTermAction } from 'src/app/actions/term';
import { ColumnOptionsComponent } from 'src/app/components/col-options/col-options.component';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';
import { CsService } from 'src/app/routes/sale/_providers/cs.service';
import { ReportTypeItem } from 'src/app/shared-feature/components/actions/preview/preview-doc.component';
import { BankChargesComponent } from 'src/app/shared-feature/components/bank-charges/bank-charges.component';
import { FurtherDescriptionComponent } from 'src/app/shared-feature/components/f-desc/f-desc.component';
import { CustomerInfoModalComponent } from 'src/app/shared-feature/components/modal/customer-info-modal/customer-info-modal.component';
import { MultiPaymentEditFormComponent } from 'src/app/shared-feature/components/multi-payments/multi-payment-edit-form.component';
import { StockSelectComponent } from 'src/app/shared-feature/components/select/stock-select/stock-select.component';
import { DocBaseService } from 'src/app/shared-feature/services/_base/doc-base.service';
import { DocListBaseService } from 'src/app/shared-feature/services/_base/doc-list-base.service';
import { AutoCodeService } from 'src/app/shared-feature/services/auto-code.service';
import { TransactionDetailColumnAdjustService } from 'src/app/shared-feature/services/transaction-detail-column-adjust.service';
import { TranscationDetailKeyKownService } from 'src/app/shared-feature/services/transcation-detail-key-kown.service';

import { PaginatedTableComponent } from '../../../../shared/components/paginated-table/paginated-table.component';
import { CsListService } from '../../_providers/cs-list.service';
import { AttachmentTableComponent } from 'src/app/shared/components/attachment-table/attachment-table.component';
import { AttachmentChangePayload } from 'src/app/shared/models/attachment-change.model';


@Component({
  selector: 'app-sale-cs-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.less'],
  standalone: false,
  providers: [
    {
      provide: DocListBaseService,
      useExisting: forwardRef(() => CsListService)
    },
    {
      provide: DocBaseService,
      useExisting: forwardRef(() => CsService)
    },
    {
      provide: CsService,
      useFactory: (injector: Injector) => new CsService(injector),
      deps: [Injector]
    },
    {
      provide: AutoCodeService,
      useFactory: (http: _HttpClient) => new AutoCodeService(http),
      deps: [_HttpClient]
    }
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsDetailComponent extends PaginatedTableComponent<CsService>
  implements AfterViewChecked, AfterViewInit, OnInit, OnDestroy {
  @ViewChild('custModal') customerInfoModal!: CustomerInfoModalComponent;
  @ViewChildren(StockSelectComponent)
  stockSelections!: QueryList<StockSelectComponent>;
  @ViewChild('notesTextArea') notesTextArea!: ElementRef;
  @ViewChild('columnOption') columnOptionComponent!: ColumnOptionsComponent;
  @ViewChild('itemDetailsTable', { static: false })
  nzTableComponent?: NzTableComponent<any>;
  @ViewChild('customerNameInput') customerNameInput!: any;
  @ViewChild('eInvStatus') eInvStatus!: EinvoiceStatusComponent;
  @ViewChild('docEditActions') docEditActions!: DocEditActionsComponent;
  @ViewChild('birComponent') birComponent!: any;
  @ViewChild('attachmentTable') attachmentTable!: AttachmentTableComponent;

  isEnableDeferredVatLookupSrv: boolean = true;
  public override newlyAddedLine: boolean = false;
  private visibleColumnsChanged: boolean = false;
  private columnPositionReset: boolean = false;

  eInvoiceVisible = false;

  // Reactive property for account validation
  isAccountRequired: boolean = false;

  classificationOption = [...EINVOICE_STOCK_CLASSIFICATION];
  countries = [...COUNTRY_OPTIONS];
  activeTabIndex = 0;

  private initialColumnOrder: string[] = [];

  get id() {
    return this.route.snapshot.params['id'];
  }

  get form() {
    return this.dataSrv.form;
  }

  get details() {
    return this.form.controls.itemDetails;
  }

  get isGovBirCat(): boolean {
    return this.dataSrv.isGovBirCat;
  }

  get country() {
    return this.settings.user['company'].country;
  }

  get isPostToAr() {
    return this.form.controls.isPostToAR.value;
  }

  get collapsed() {
    return this.settings.layout.collapsed;
  }

  get regNoLabel(): string {
    if (this.dataSrv.isEInvEnabled === true) {
      switch (this.dataSrv.form.controls.customerTinType.value) {
        case 2:
          return 'Identification No.';
        case 4:
          return 'Passport No.';
        default:
          return 'Registration No.';
      }
    }
    return 'Registration No.';
  }

  get doRegNoLabel(): string {
    if (this.dataSrv.isEInvEnabled === true) {
      switch (this.dataSrv.form.controls.dotinType.value) {
        case 2:
          return 'Identification No.';
        case 4:
          return 'Passport No.';
        default:
          return 'Registration No.';
      }
    }
    return 'Registration No.';
  }

  get tinPlaceHolder(): string {
    if (this.dataSrv.isEInvEnabled === true) {
      switch (this.dataSrv.form.controls.customer.value) {
        case 1:
          return 'eg. C2584563202';
        case 2:
          return 'eg. IG56003500070';
        case 3:
          return 'eg. EI00000000010';
        case 4:
          return 'eg. EI00000000020';
        default:
          return '';
      }
    }
    return '';
  }

  get isConsolidated(): boolean {
    return this.dataSrv._data.consolidatedUIN
  }

  validateRemainingQty(event: any, row: any) {
    // future: retrieve value from setting
    const allowTransferMore = true;
    if (!allowTransferMore) {
      let qty: number = event.newValue;
      /// do checking, get the right qty value;
      if (row.transferFromQuotationDetail) {
        const remainingQty = row.transferFromQuotationDetail.remainingQty;
        if (+qty > +remainingQty) event.newValue = remainingQty;
      }
      if (row.transferFromSalesOrderDetail) {
        const remainingQty = row.transferFromSalesOrderDetail.remainingQty;
        if (+qty > +remainingQty) event.newValue = remainingQty;
      }
      if (row.transferFromDeliveryOrderDetail) {
        const remainingQty = row.transferFromDeliveryOrderDetail.remainingQty;
        if (+qty > +remainingQty) event.newValue = remainingQty;
      }
    }
  }

  constructor(
    private route: ActivatedRoute,
    public msgSrv: NzMessageService,
    public override dataSrv: CsService,
    private modalSrv: NzModalService,
    protected override cdr: ChangeDetectorRef,
    public acl: ACLService,
    public settings: SettingsService,
    public router: Router,
    public override keyDownService: TranscationDetailKeyKownService,
    public columnAdjustService: TransactionDetailColumnAdjustService,
    private injector: Injector,
    private store: Store<{
      term: { recentTerm: any };
      agent: { recentAgent: any };
      project: { recentProject: any };
      customer: { recentCustomer: any };
      stock: { recentStock: any };
      tax: { recentTax: any };
    }>,
    private userDefaultService: UserDefaultService
  ) {
    // Call the parent constructor with required parameters
    super(dataSrv, cdr, keyDownService);

    // CsDetailComponent-specific initialization
    this.dataSrv.parentComponent = this;

    this.dataSrv.newLineAdded$.subscribe(() => {
      this.newlyAddedLine = true;
    });

    this.dataSrv.lineValueChanged.subscribe(({ line, controlName }) => {
      const index = this.dataSrv.itemDetails.controls.indexOf(line);
      this.keyDownService.focusNextElement(
        index,
        controlName,
        this.visibleColumns,
        this.editableCells.toArray()
      );
    });
  }

  override visibleColumns: ColumnOptions[] = [];
  initialColumns: ColumnOptions[] = [];
  destroy$ = new Subject<void>();
  recentStockControlIndex?: number;
  recentTaxControlIndex?: number;
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
  @ViewChildren('inputWrapper') inputWrappers!: QueryList<ElementRef>;

  ngOnInit(): void {
    this.checkDeferredVatSetting();
    this.store.dispatch(removeRecentAgentAction());
    this.store.dispatch(removeRecentCustomerAction());
    this.store.dispatch(removeRecentProjectAction());
    this.store.dispatch(removeRecentTermAction());
    this.store.dispatch(removeRecentStockAction());
    this.store.dispatch(removeRecentTaxAction());
    this.dataSrv.setComponentRef(this);

    // Subscribe to form control changes to update validation state
    this.form.controls.isPostToAR.valueChanges.subscribe(() => {
      this.updateAccountValidation();
    });

    this.form.controls.isMultiPayment.valueChanges.subscribe(() => {
      this.updateAccountValidation();
    });

    // Note: Initial validation state will be set after form data is loaded in the service

    if (this.id == 0) {
      this.onProjectCreate();
      this.onTermAdded();
      this.onAgentAdded();
      this.onAddNewCustomer();
      this.onStockCreate();
      this.onTaxCreate();
    }

    this.form.controls.customer.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.dataSrv.applyGovWvatColumnVisibility('cs-details')) {
          this.visibleColumnsChanged = true;
          this.cdr.markForCheck();
        }
      });
  }

  checkDeferredVatSetting() {
    if (this.country === "PH") {
      this.injector.get(DeferredVatLookupService).loadDeferredVatSettings().subscribe(res => {
        this.isEnableDeferredVatLookupSrv = res === null ? false : res;
        this.dataSrv.form.controls.enableDeferredVat.setValue(this.isEnableDeferredVatLookupSrv);
      });
    }
  }

  private onTaxCreate() {
    this.store
      .select('tax')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentTax === null) return;
        if (
          isNull(this.recentTaxControlIndex) ||
          isUndefined(this.recentTaxControlIndex) ||
          this.dataSrv.itemDetails.at(this.recentTaxControlIndex).controls
            .taxCode.value
        )
          return;
        const rowControl = this.dataSrv.itemDetails.at(
          this.recentTaxControlIndex
        );
        rowControl.controls.taxCode.setValue(state.recentTax);
        rowControl.controls.taxCodeId.setValue(state.recentTax.id);
      });
  }
  private onStockCreate() {
    this.store
      .select('stock')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentStock === null) return;
        if (
          isNull(this.recentStockControlIndex) ||
          isUndefined(this.recentStockControlIndex) ||
          this.dataSrv.itemDetails.at(this.recentStockControlIndex).controls
            .taxCode.value
        )
          return;
        const rowControl = this.dataSrv.itemDetails.at(
          this.recentStockControlIndex
        );
        rowControl.controls.stock.setValue(state.recentStock);
        rowControl.controls.stockId.setValue(state.recentStock.id);
        rowControl.controls.stockLocation.setValue(state.recentStock.location);
        rowControl.controls.stockId.setValue(state.recentStock.locationId);
      });
  }
  private onProjectCreate() {
    this.store
      .select('project')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentProject === null) return;
        if (
          this.form.controls.projectId.value ||
          this.form.controls.project.value
        )
          return;
        this.form.controls.project.setValue(state.recentProject);
        this.form.controls.projectId.setValue(state.recentProject.id);
      });
  }
  private onTermAdded() {
    this.store
      .select('term')
      .pipe(takeUntil(this.destroy$))
      .subscribe(term => {
        if (this.dataSrv.form.controls.termId.value) return;
        if (term.recentTerm) {
          this.dataSrv.form.controls.termId.setValue(term.recentTerm.id);
          this.dataSrv.form.controls.term.setValue(term.recentTerm);
        }
      });
  }
  private onAgentAdded() {
    this.store
      .select('agent')
      .pipe(takeUntil(this.destroy$))
      .subscribe(agent => {
        if (this.dataSrv.form.controls.agentId.value) return;
        if (agent.recentAgent) {
          this.dataSrv.form.controls.agentId.setValue(agent.recentAgent.id);
          this.dataSrv.form.controls.agent.setValue(agent.recentAgent);
        }
      });
  }
  onAddNewCustomer() {
    this.store
      .select('customer')
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        if (state.recentCustomer === null) return;
        this.form.controls.customer.setValue(state.recentCustomer);
        this.form.controls.customerId.setValue(state.recentCustomer?.id);
        this.form.controls.customerName.setValue(state.recentCustomer?.name);
        this.form.controls.customerPhone.setValue(
          state.recentCustomer?.phoneNo1
        );
        this.form.controls.customerTinType.setValue(
          state.recentCustomer?.tinType
        );
      });
  }
  ngAfterViewInit(): void {
    /**
     * column data should in take after onInit because to make the column chooser ngOninit data done processed
     * if not column in here will be overwrite by column chooser, the console log data will confused
     */

    this.dataSrv.applyGovWvatColumnVisibility('cs-details');

    this.visibleColumns = this.dataSrv.columns.filter(
      col =>
        (!col.acl || this.acl.canAbility(col.acl)) &&
        col.visible &&
        (!col.isGov || col.isGov === this.isGovBirCat)
    );

    this.initialColumns = JSON.parse(JSON.stringify(this.visibleColumns));
    this.initialColumnOrder = this.initialColumns.map(col => col.name);

    this.columnAdjustService.setInitialColumn(this.initialColumns);

    const savedOrder = this.columnAdjustService.loadColumnOrder('cs');
    if (savedOrder) {
      this.visibleColumns.sort(
        (a, b) => savedOrder[a.key || ''] - savedOrder[b.key || '']
      );
    }

    // if column visible have update
    this.columnOptionComponent.visibleColiumnsChanged$.subscribe(() => {
      this.visibleColumnsChanged = true;
    });

    // if column position want to be reset
    this.columnOptionComponent.columnPositionReset$.subscribe(
      (initialOrder: string[]) => {
        this.initialColumnOrder = initialOrder;
        this.columnPositionReset = true;
      }
    );

    this.dataSrv.setFromRecurring();
    this.inputWrappers.forEach(wrapper => {
      this.userDefaultService.setRequiredValidation(wrapper);
    });
    this.dataSrv.validateTaxDate();

    this.dataSrv.updateAccAndCustValidator();
  }

  get reportType() {
    if (this.id) return 'cs-voucher';
    return undefined;
  }

  reportTypes: ReportTypeItem[] = [{ reportType: 'cs-voucher' }];

  reload() {
    this.dataSrv.triggerEvent({ type: 'reload', id: this.dataSrv.id });
  }

  onCustomerChange() {
    if (this.dataSrv.editing){
      // Focus on customer name field after customer selection
      setTimeout(() => {
        if (this.customerNameInput) {
          this.customerNameInput.focus();
        }
      }, 100);
    }
  }

  reloadDetailTable() {
    this.dataSrv.applyGovWvatColumnVisibility('cs-details');
    this.visibleColumns = this.dataSrv.columns.filter(
      col =>
        (!col.acl || this.acl.canAbility(col.acl)) &&
        col.visible &&
        (!col.isGov || col.isGov === this.isGovBirCat)
    );

    this.initialColumns = JSON.parse(JSON.stringify(this.visibleColumns));
    this.initialColumnOrder = this.initialColumns.map(col => col.name);

    this.columnAdjustService.setInitialColumn(this.initialColumns);

    const savedOrder = this.columnAdjustService.loadColumnOrder('cs');
    if (savedOrder) {
      this.visibleColumns.sort(
        (a, b) => savedOrder[a.key || ''] - savedOrder[b.key || '']
      );
    }

    // if column visible have update
    this.columnOptionComponent.visibleColiumnsChanged$.subscribe(() => {
      this.visibleColumnsChanged = true;
    });

    // if column position want to be reset
    this.columnOptionComponent.columnPositionReset$.subscribe(
      (initialOrder: string[]) => {
        this.initialColumnOrder = initialOrder;
        this.columnPositionReset = true;
      }
    );
  }

  onResize({ width }: NzResizeEvent, col: any): void {
    col.width = `${width}px`;
  }

  populateDOAddress(data: any) {
    this.dataSrv.populateDOAddress(data);
  }

  updateLatestRate() {
    this.dataSrv.updateLatestRate();
  }

  bankChargesModal() {
    const modal = this.modalSrv.create({
      nzTitle: 'Bank Charges',
      nzContent: BankChargesComponent,
      nzWidth: '600px',
      nzOnOk: component => {
        const instance = modal.getContentComponent();
        this.form.controls.bankChargesAccountId.setValue(
          instance.bankChargesAccountId
        );
      }
    });
    const instance = modal.getContentComponent();
    instance.bankChargesAccountId =
      this.form.controls.bankChargesAccountId.value;
  }

  updateCustModal(data: any) {
    this.dataSrv.updateCustInfo(data);
  }

  focusElement(name: string): boolean {
    if (
      name === 'doIdentificationNo' ||
      name === 'doZipCode' ||
      name === 'doCity' ||
      name === 'dotinNo'
    ) {
      this.activeTabIndex = 3;
    } else if (
      name === 'detailsTaxExemption' ||
      name === 'identificationNo' ||
      name === 'tinNumber'
    ) {
      this.activeTabIndex = 1;
    } else {
      this.activeTabIndex = 0;
    }
    setTimeout(() => {
      this.dataSrv.fs.focusInvalidControl();
    }, 200);
    return true;
  }

  fDescriptionModal(line: any) {
    const modal = this.modalSrv.create({
      nzTitle: 'F. Desc',
      nzContent: FurtherDescriptionComponent,
      nzWidth: '800px',
      nzOnOk: component => {
        const instance = modal.getContentComponent();
        line.controls.docFurtherDescription.setValue(instance.getPersistedHtml());
      }
    });
    const instance = modal.getContentComponent();
    instance.fdescHtml = line.controls.docFurtherDescription.value;
  }

  openCustModal() {
    // Pass existing data to ensure data recovery can be done when changes are cancelled
    this.customerInfoModal.show(this.dataSrv.form.value, 'CS');
  }

  ngAfterViewChecked() {
    if (this.newlyAddedLine) {
      this.focusNewLineStockSelect();
      this.newlyAddedLine = false;
      this.cdr.detectChanges();
    }

    // Phase 1: Update visible columns if there are changes
    if (this.visibleColumnsChanged) {
      // Create a map of the current visible columns
      const currentVisibleMap = new Map(
        this.visibleColumns.map(col => [col.name, col])
      );

      // Filter out columns that are no longer visible or accessible based on ACL
      this.visibleColumns = this.visibleColumns.filter(
        col =>
          (!col.acl || this.acl.canAbility(col.acl)) &&
          this.dataSrv.columns.find(c => c.name === col.name)?.visible &&
          (!col.isGov || col.isGov === this.isGovBirCat)
      );

      // Add any new visible columns that were not in the current map
      this.dataSrv.columns.forEach(col => {
        if (
          (!col.acl || this.acl.canAbility(col.acl)) &&
          col.visible &&
          !currentVisibleMap.has(col.name) &&
          (!col.isGov || col.isGov === this.isGovBirCat)
        ) {
          this.visibleColumns.push(col);
        }
      });

      // Reset the flag and detect changes to update the view
      this.visibleColumnsChanged = false;
      this.cdr.detectChanges();
    }

    // Phase 2: Reset column positions if requested
    if (this.columnPositionReset) {
      // Reorder the visible columns based on the initial column order
      this.visibleColumns = this.initialColumnOrder
        .map(name => this.visibleColumns.find(col => col.name === name))
        .filter(col => col !== undefined) as ColumnOptions[];

      // Reset the column order in the column adjust service
      this.columnAdjustService.resetColumnOrder('cs');

      // Reset the flag and detect changes to update the view
      this.columnPositionReset = false;
      this.cdr.detectChanges();
    }
  }

  private focusNewLineStockSelect() {
    const stockSelectionArray = this.stockSelections.toArray();
    if (stockSelectionArray.length > 0) {
      const newLineStockSelect =
        stockSelectionArray[stockSelectionArray.length - 1];
      newLineStockSelect.focus();
    }
  }

  columnOrder: string[] = [];
  override selectComponentArray: string[] = [
    'stock',
    'project',
    'uom',
    'stockLocation',
    'taxCode',
    'wTaxCode',
    'account',
    'classification',
    'tariffCode',
    'taxAmountAdjustment',
    'wTaxAmountAdjustment'
  ];
  @ViewChildren('editableCell') override editableCells!: QueryList<ElementRef>;

  timestamp() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    var formattedTimestamp = null;
    if (this.settings.user['country'] === 'MY')
      formattedTimestamp = `${day}/${month}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.settings.user['country'] === 'PH')
      formattedTimestamp = `${month}/${day}/${year} ${hours}:${minutes}:${seconds} - ${this.settings.user['displayName']}:`;
    if (this.dataSrv.form.controls.notes.value)
      formattedTimestamp = `${this.dataSrv.form.controls.notes.value}\n${formattedTimestamp}`;

    this.dataSrv.form.controls.notes.setValue(formattedTimestamp);
    this.notesTextArea.nativeElement.focus();
  }

  addMultiPayment() {
    const newPayment = this.dataSrv.createMultiPaymentForm();
    const modal = this.dataSrv.modalService.create({
      nzTitle: 'New Multi-Payment',
      nzContent: MultiPaymentEditFormComponent,
      nzWidth: '600px',
      nzOnOk: component => {
        return new Promise((resolve, reject) => {
          if (!this.dataSrv.formSrv.validate(component.form).isValid) {
            reject();
          }
          else {
            newPayment.patchValue(component.value);
            this.dataSrv.form.controls.multiPayments.push(newPayment);
            this.cdr.detectChanges();
            resolve();
          }
        });
      }
    });
    const instance = modal.getContentComponent();
    instance.setDescription(this.dataSrv.form.controls.customerName.value || '');
  }

  editMultiPayment(index: number) {
    const payment = this.dataSrv.form.controls.multiPayments.at(index);
    const modal = this.dataSrv.modalService.create({
      nzTitle: 'Edit Multi-Payment',
      nzContent: MultiPaymentEditFormComponent,
      nzWidth: '600px',
      nzOnOk: component => {
        return new Promise((resolve, reject) => {
          if (!this.dataSrv.formSrv.validate(component.form).isValid) {
            reject();
          }
          else {
            payment.patchValue(component.value);
            this.cdr.detectChanges();
            resolve();
          }
        });
      }
    });
    const instance = modal.getContentComponent();
    instance.value = payment.value;
  }

  get isMultiPaymentDisabled() {
    return this.dataSrv.form.controls.isMultiPayment.value === false;
  }

  private updateAccountValidation() {
    // Account is required when isPostToAR is false AND isMultiPayment is false
    this.isAccountRequired =
      this.form.controls.isPostToAR.value === false &&
      this.form.controls.isMultiPayment.value === false;
  }

  collectAttachmentChanges(): AttachmentChangePayload | null {
    if (this.attachmentTable) {
      return this.attachmentTable.getDeferredAttachmentChanges();
    }
    return null;
  }

  clearAttachmentChanges(): void {
    if (this.attachmentTable) {
      this.attachmentTable.clearDeferredChanges();
    }
  }
}
